import { render, staticRenderFns } from "./zero-products.vue?vue&type=template&id=70050cd2&"
import script from "./zero-products.vue?vue&type=script&lang=js&"
export * from "./zero-products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports